<template>
    <b-modal :no-close-on-backdrop="true"
        id="modal-Create"
        title="Property Versioning" 
        hide-footer 
        :centered="true"
        modal-class="modal-property-config"
        body-class="px-0 pb-0"
        v-model="open">
        <b-form class="pl-15 pr-15">
            <b-row align-v="center">
                <b-col md="3">
                    <gofix-form-dropdown
                        label="Configured As"
                        v-model="modal.configured_as"
                        :options="configuredAs">
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="3">
                    <gofix-form-input-date 
                        label="Effective Date" 
                        :disabled="modal.is_current"
                        popoverDirection="bottom"
                        :min-date="minDate"
                        v-model="modal.effective_date" >
                    </gofix-form-input-date>
                </b-col>
                <b-col md="2">
                    <b-form-checkbox v-model="modal.lettable" class="ml-3 checkbox-top-5"><span class="ml-3">Lettable</span></b-form-checkbox>
                </b-col>
                <!-- Save Changes & Update Properties -->
                <b-col md="4">
                    <gofix-button class="ml-2" label="Save Changes & Update Properties" outline :loading="loading" @click="saveData"></gofix-button>
                </b-col>
            </b-row>
        </b-form>
        <gofix-table
            :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @new-item="setItem"
            @delete-items="deleteItems"
            ref="gofixTable">
            <template slot="gofix_table:edit" slot-scope="row">
                <button 
                    type="button" 
                    class="icon-button position-relative"
                    @click="setItem(row.item)">
                    <img width="20" src="img/iconPencil.png" alt="" />
                </button>
            </template>
            <template slot="gofix_table:lettable" slot-scope="row">
                {{ row.item.lettable ? 'Yes' : 'No' }}
            </template>
            <template slot="gofix_table:effective_date" slot-scope="row">
                {{ row.item.effective_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
            </template>
        </gofix-table>
    </b-modal>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';
    const fieldDefault = [
        {
            key: 'actions',
            label: '',
            thStyle: "width:50px",
            isActive: 1,
            isFilter: false,
            sorting: false
        },
        {
            key: 'configured_as',
            label: 'Configured As',
            thStyle: "width:170px",
            isActive: 1,
            isFilter: true,
            sorting: true
        },
        {
            key: 'effective_date',
            label: 'Effective Date',
            thStyle: "width:170px",
            isActive: 1,
            isFilter: true,
            sorting: true
        },
        {
            key: 'lettable',
            label: 'Lettable',
            isActive: 1,
            thStyle: "width:150px",
            isFilter: true,
            sorting: true
        },
        {
            key: 'edit',
            label: '',
            isActive: 1,
            thStyle: "width:100px",
            isFilter: false,
            sorting: false
        }
    ];
    export default {
        name: 'property-versioning',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            property_id: {
                type: Number,
                default: null
            }
        },
        data () {
            let filter = JSON.parse(JSON.stringify(filters['property_versioning']));
            return {
                open: false,
                loading: false,
                modal: {
                    configured_as: null,
                    effective_date: null,
                    lettable: false
                },
                configuredAs:['MT', 'Hostel', 'Bare'],
                minDate: new Date(),
                tableConfig:{
                    name: 'property-versioning',
                    controls:{
                        tableExport: false,
                        tableImport: false,
                        tableColumnSettings: false,
                        tableFilter: false
                    },
                    fields: JSON.parse(JSON.stringify(fieldDefault)),
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "effective_date",
                    sortDirection: "desc",
                },
                tableItems: [],
            }
        },
        watch: {
            value: function(val) {
                this.modal = {
                    configured_as: null,
                    effective_date: null,
                    lettable: false
                };
                this.open = val;
            },
            open: function(val) {
                this.$emit('input', val);
            }
        },
        created() {},
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.property_id.value = this.property_id;
                await this.$store.dispatch("PropertyVersioningController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the items", "danger");
                    reject();
                })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("PropertyVersioningController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'fm_officer'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            setItem(item = null) {
                if(!item) {
                    this.modal = {
                        configured_as: null,
                        effective_date: null,
                        lettable: false
                    };
                    return;
                }
                this.modal = Object.assign({}, item);
                this.modal.effective_date = moment(this.modal.effective_date).toDate();
            },
            saveData() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    if(this.loading) return;
                    if(!this.modal.effective_date) return this.$alertNotification("Effective date is required", "danger");
                    if(!this.modal.configured_as) return this.$alertNotification("Configured as is required", "danger");

                    this.loading = true;
                    let request = Object.assign({}, this.modal);
                    request.property_id = this.property_id;
                    request.effective_date = moment(request.effective_date).format("YYYY-MM-DD");

                    let api = "createItem";
                    let key = "adding";
                    if(this.modal.id) {
                        api = "updateItem";
                        key = "editing";
                    }

                    this.$store.dispatch(`PropertyVersioningController/${api}`, request)
                        .then(response => {
                            this.loading = false;
                            this.$alertNotification(this.$notificationV2(key, 'property_versioning'));
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.$emit("storeDataSuccess", response);
                            if(!this.modal.id) this.setItem();
                        })
                        .catch(error =>{
                            this.loading = false;
                            if(error.response.data.error.message.error) {
                                this.$alertNotification(error.response.data.error.message.error, "danger");
                            }
                        });
                }, 300);
            }
        }
    }
</script>